

import { useState, useEffect } from "react";
import MKTypography from "components/MKTypography"; 
import MKBadge from "components/MKBadge";
import MKInput from "components/MKInput";
import Divider from "@mui/material/Divider";
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import { appAuth } from "../../contexts/AppContext"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import Dropdowns from "components/AppKey/Dropdowns";
import InputAdornment from "@mui/material/InputAdornment"; 
import SearchIcon from "@mui/icons-material/Search";





export default function AddUserGroup({groupId, app, onSubmit, dismiss}) { 

    const {getAppUser} =  appAuth()
    const [message, setMessage] = useState("")
    const [error, setErrorMessage] = useState("")
    const [data, setData] = useState({ groupId:groupId, appId:app.appId})
    const [filter, setFilter] = useState({appId:app.appId, type:"all", limit:25, offset: 0})
    const [search, setSearch] = useState("")

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [total, setTotal] = useState();
    
    const [applyAll, setApplyAll] = useState(false);

    const [userData, setUserData] = useState([]);
    const [userDataRender, setUserDataRender] = useState([]);
    
    let userTableHeader = [
        { id:"number", name: "no", align: "left", maxWidth:100 },
        { id: "handle",  name: "handle", align: "center" },
        { id: "displayName",  name: "Name", align: "center" },  
        { id: "status", name: "status", align: "center" }, 
        { id: "select", name: "select", align: "center" },
    ]

    if(app.userNamesEnabled) {
        userTableHeader = [

            { id:"number", name: "no", align: "left", maxWidth:100  },
            { id: "handle",  name: "handle", align: "center" },
            { id: "displayName",  name: "Name", align: "center" }, 
            { id: "userName",  name: "userName", align: "center" },  
            { id: "status", name: "status", align: "center" }, 
            { id: "select", name: "select", align: "center" },
        ]
    }


    useEffect(() => {
      

       getAppUserData()

    }, [])

    

    const submitAddUserGroup = async () => {
        setErrorMessage("")
        setMessage("")  
       
       
         
        let toAddUser = userDataRender.filter(user => user.selected === true  && user.groupIds.indexOf(data.groupId) < 0)
        let toRemoveUser = userDataRender.filter(user =>  
                user.selected === false && user.groupIds.indexOf(data.groupId) >= 0
            
        )

        // console.log("toAddUser ", toAddUser)
        // console.log("toRemoveUser ", toRemoveUser)

        onSubmit({toAddUser:  toAddUser.map(item => item.appUserId ),
                toRemoveUser: toRemoveUser.map(item => item.appUserId )}) 

        clearSelection();

    }

    const getSelectedUser = () => {
        return userDataRender.filter(item => item.selected === true).length
    }

    const clearSelection = () => {
        setUserData(userData.map(item => { 
            return {...item, selected : item.groupIds.indexOf(data.groupId) >= 0 ? true : false} 
        })); 

        setUserDataRender(userDataRender.map(item => { 
            return {...item, selected : item.groupIds.indexOf(data.groupId) >= 0 ? true : false} 
        })); 

    }
    

    const getAppUserData = async() => { 
        getSelectedUser()

        setFilter({
            ...filter, 
            ["search"]: search
        });
       
        console.log("getAppUserData filter ", filter)

        let result = await getAppUser(filter)

        setUserData(prevItems => { 
            return [];
        }); 

        setUserDataRender(prevItems => { 
            return [];
        });  

        if (!result || !result.data) return

        setTotal(result.total || 0)

       

        for (let index = 0; index < result.data.length; index++) {
            
            let element = makeUserRecord(result.data[index]); 
            element.number = index + 1 
         
            

            setUserData(prevItems => { 
                return [...prevItems, element];
            });  

            setUserDataRender(prevItems => { 
                return [...prevItems, element];
            });  
            
           
        } 
    }

    
    const makeUserRecord = (item) => { 
        
        item.selected = item.groupIds.indexOf(groupId) >= 0? true : false;
        item.displayName = item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : ""
        item.hide = false  
        return item
          
    }

     
    
    const handleChangePage = (event, newPage) => {
        console.log("handleChangePage newPage ", newPage); 
        setPage(newPage);
        setFilter({
            ...filter,
            ["offset"]: newPage
        });

        
    };

    function onKeyEnterSearch(event){
        if(event.keyCode == 13) applyFilter()
    }

    
    function onSearchUser (evt)  { 
        let value = evt.target.value
        setSearch(value)
      
    
        setUserDataRender(
            userData.filter(data =>
                data.handle.indexOf(value) >= 0
        )); 

        

        if(search === "") getAppUserData()

    }

    const onSelectUser = (user) => {
       

        setUserData(userData.map(item => { 
            if (item.appUserId === user.appUserId){ 
                return {...item, selected:!user.selected}
            } 
            else return item
        })); 

        setUserDataRender(userDataRender.map(item => { 
            if (item.appUserId === user.appUserId){ 
                return {...item, selected:!user.selected}
            } 
            else return item
        })); 


    }

    const applyAllSelect = () => {
       

        if(!applyAll){
            setUserData(userData.map(item => { 
                return {...item, selected:true}
            })); 
    
            setUserDataRender(userDataRender.map(item => { 
                return {...item, selected:true}
            })); 
        }
        else {
            setUserData(userData.map(item => { 
                return {...item, selected:false}
            })); 
    
            setUserDataRender(userDataRender.map(item => { 
                return {...item, selected:false}
            })); 
        }

        setApplyAll(!applyAll)
    }
     
 
    return(

    <MKBox>
        
        {error && <MKTypography variant="button" color="error" px={2}>{error}</MKTypography> }
        {message && <MKTypography variant="body2" color="info" px={2}>{message}</MKTypography>}
        <Divider sx={{ my: 0 }} />
        <MKBox alignItems="center" justifyContent="left" display="flex">
        
            <MKTypography variant="caption" color="text">  Show:  </MKTypography> 
            <Dropdowns items={[25,  100, 150]} defaultValue = {rowsPerPage}  /> 
            <MKTypography variant="caption" color="text"> entries  </MKTypography> 

            <MKBox px={3}> 
                <MKTypography variant="h7" color="text"> Total Record: {total}  </MKTypography>
            </MKBox>

            <MKInput
                variant="standard"
                placeholder="Search"
                id = "searchValue"
                name = "searchValue"
                autoFocus={true}
                value={search} 
                onKeyDown = {onKeyEnterSearch}
                onChange={e => {onSearchUser(e)} }
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                        </InputAdornment>
                    ), 
            }} />
                
        </MKBox>

        <MKBox alignItems="right" justifyContent="right" display="flex">
            <MKBox px={1}> 
                <MKTypography variant="caption" color="text"> Selected({getSelectedUser()}) </MKTypography>
            </MKBox> 
            {applyAll ?
                 
                <MKBox px={1}> 
                    <MKTypography variant="caption" color="text"> Unselect All: </MKTypography>
                    <MKButton variant="text" color="error" iconOnly px={2} onClick = { applyAllSelect } ><Icon>check_box </Icon></MKButton>
                </MKBox> 
                
                :
                 
                <MKBox px={1}> 
                    <MKTypography variant="caption" color="text"> Select All: </MKTypography>
                    <MKButton variant="text" color="info" iconOnly px={2} onClick = { applyAllSelect } ><Icon>check_box_outline_blank </Icon></MKButton>
                </MKBox> 
                 
            }
        </MKBox>   
        
        <TableContainer sx={{ maxHeight: 650 }}>
            <Table responsive="sm">
                <thead>
                <TableRow>
                {userTableHeader.map((column) => (
                    <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ maxWidth: column.maxWidth }}
                    className="colunmHeader"
                    >
                    {column.name}
                    </TableCell>
                ))}
                </TableRow>
                </thead>
            <TableBody>
                {userDataRender
                //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((user) => {
                    return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={user.number}>
                        {userTableHeader.map((column) => {

                            let value = user[column.id];

                            if (column.id === "status") { 

                                return (
                                    <TableCell key={column.id} align={column.align} className="tableCell">
                                        { value === "active" ?  <MKBadge variant="contained" badgeContent= {value} color="success" size="xs" container /> :
                                                                <MKBadge variant="contained" badgeContent= {value} color="error" size="xs" container />
                                        }

                                    </TableCell>
                                );
                            }

                            else if (column.id === "select") {
                                return (
                                    <TableCell key={column.id} align={column.align} className="tableCell">
                                        <MKBox>
                                            
                                           
                                            { user.selected === true ?   
                                                <Tooltip title="remove from group" placement="top">
                                                    <MKButton variant="text" color="success"  iconOnly px={2}  onClick = {() => onSelectUser(user) } ><Icon>check_box</Icon></MKButton>
                                                </Tooltip> 
                                                : 
                                                <Tooltip title="add to group" placement="top">
                                                <MKButton variant="text" color="info" iconOnly px={2} onClick = {() => onSelectUser(user) } ><Icon>check_box_outline_blank </Icon></MKButton>
                                                </Tooltip>
                                            }

                                        </MKBox>   
                                    </TableCell>
                                );
                            }
                            else { 


                                return (
                                    <TableCell key={column.id} align={column.align} className="tableCell">
                                    {column.format && typeof value === 'number'
                                        ? column.format(value)
                                        : value}
                                    </TableCell>
                                );
                            }
                        })}
                    </TableRow>
                    );
                })}
            </TableBody>

            
            </Table>
        </TableContainer>
        

        <Divider sx={{ my: 0 }} />
       
        
        {Math.ceil(total/rowsPerPage) > 1 &&  
            <Grid container item xs={12} lg={5} justifyContent="center" mx="auto" py={3}> 
                <Pagination count={Math.ceil(total/rowsPerPage)} showFirstButton showLastButton page={page} onChange={handleChangePage} />
            </Grid>
        }
        
        
        <MKBox display="flex" justifyContent="space-between" p={1.5}>

            <MKButton variant="gradient" color="dark" onClick={dismiss}>
                Close
            </MKButton>

            <MKButton variant="gradient" color="primary" onClick={submitAddUserGroup}  >
                Submit
            </MKButton>

        </MKBox>
        
        
    
    </MKBox>

    )
}

